module.exports = __webpack_public_path__ + "img/Ghana.e0699143.svg";